export const htmlStringToText = (htmlString) => {
  try {
    if (!htmlString) return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent?.trim() || "";
  } catch (error) {
    console.error("Error converting HTML to text:", error);
    return htmlString;
  }
};
